import React, { useState } from 'react';
import './ModalPasswordInput.css';

const ModalPasswordInput = ({ id = 'password', name, value, onChange, className, disabled, placeholder }) => {
    const SHOW_PASSWORD_ICON_CLASS = "fa fa-eye password-icon";
    const HIDE_PASSWORD_ICON_CLASS = "fa fa-eye-slash password-icon";
    const INPUT_TEXT = "text";
    const INPUT_PASSWORD = "password";
    const ICON_COLOR_BLACK = "black";
    
    const [inputType, setInputType] = useState(INPUT_PASSWORD);
    const [iconClass, setIconClass] = useState(HIDE_PASSWORD_ICON_CLASS);
    const [iconColor, setIconColor] = useState(ICON_COLOR_BLACK);

    const toggle = name ? `#${name}` : "#defaultPasswordToggle";

    const handleShowPasswordClick = () => {
        const newInputType = inputType === INPUT_TEXT ? INPUT_PASSWORD : INPUT_TEXT;
        const newIconClass = inputType === INPUT_TEXT ? HIDE_PASSWORD_ICON_CLASS : SHOW_PASSWORD_ICON_CLASS;
        setInputType(newInputType);
        setIconClass(newIconClass);
        setIconColor(ICON_COLOR_BLACK);
    };

    return (
        <>
            <input
                type={inputType}
                id={id}
                disabled={disabled}
                className={className || ""}
                name={name || ""}
                value={value}
                placeholder={placeholder || ""}
                onChange={onChange}
                autoComplete="off"
            />
            <span 
                toggle={toggle}
                className={iconClass}
                style={{ color: iconColor }}
                onClick={handleShowPasswordClick}
            />
        </>
    );
};

export default ModalPasswordInput;
